// A plot request raised by the logic engine's `plot` action or the Vitals body-
// measures cards; App.svelte renders a PlotModal for it. Cleared on close.
import { writable } from 'svelte/store';

export interface PlotPoint { t: number; y: number; }
export interface PlotPreset { id: string; l: string; days: number; }
export interface PlotSpec {
  title: string;
  unit: string;
  series: { color: string; points: PlotPoint[] }[];
  clinical?: boolean;          // clinical feature set: long windows + admissions + values table
  ranges?: boolean;            // day-window range presets (high-frequency vitals)
  presets?: PlotPreset[];      // override the preset window buttons for this plot
  defaultRange?: string;       // preset id (or 'all') selected when the modal opens
  connect?: boolean;           // connect all markers with a line (never break across gaps)
  padFrac?: number;            // axis headroom: extend x-max & y-max by this fraction of the data range
}

export const plotRequest = writable<PlotSpec | null>(null);
